import { CheckBadgeIcon, FunnelIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../utils";
import {
  AssignmentActionDef,
  AssignmentFilterData,
  AssignmentPopover,
} from "./AssignmentFilterPopover";

type CheckAssignmentTableHeaderCellProps = {
  children: React.ReactNode;
  hasIcon?: boolean;
  filterCount?: number;
  filterData?: AssignmentFilterData[];
  onAction: AssignmentActionDef;
  className?: string;
  headerKey: string;
  isSubCell?: boolean;
  filterApplied?: boolean;
  /** Every Nth task column: left rule (rotating colors) for scroll alignment. */
  columnGroupClasses?: string;
};

export function CheckAssignmentTableHeaderCell({
  children,
  hasIcon,
  filterCount,
  filterData,
  onAction,
  className,
  headerKey,
  isSubCell,
  filterApplied,
  columnGroupClasses,
}: CheckAssignmentTableHeaderCellProps) {
  return (
    <div
      className={classNames(
        isSubCell ? "flex flex-1 text-sm" : "",
        className ?? "flex-1 items-center justify-center p-2",
        columnGroupClasses ?? ""
      )}
    >
      <div className="flex flex-1 items-center justify-center font-bold">
        {children}
      </div>
      <div>
        {hasIcon && (
          <AssignmentPopover
            onAction={onAction}
            data={filterData ?? []}
            headerKey={headerKey}
          >
            <div
              className={classNames(
                "flex items-center justify-center font-extralight text-sm relative",
                isSubCell ? "w-16" : ""
              )}
            >
              {filterCount !== undefined && (
                <span className="m-auto">({filterCount ?? 0})</span>
              )}
              <FunnelIcon className="text-gray-400 w-5 absolute right-0" />
              {filterApplied && (
                <CheckBadgeIcon className="text-green-400 w-3 absolute right-[-4px] bottom-0" />
              )}
            </div>
          </AssignmentPopover>
        )}
      </div>
    </div>
  );
}
